module.exports = __webpack_public_path__ + "static/media/textMobi.aa9eb1da.PNG";